import { MutationOptions } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { Immutable } from 'immer'

export enum DeltakerTypes {
  VIRKSOMHET = 'virksomhet-deltagere',
  MATTILSYNET = 'mattilsynet-deltagere',
  ANDRE = 'andre-deltagere',
}

export interface IDeltaker {
  id: string | number
  navn: string
  _links?: {
    self: {
      href: string
    }
  }
}

export type IDeltakerMutateVars = {
  kvitteringId: string
} & IDeltakerVars

export interface IDeltakerVars {
  deltaker: IDeltaker
  type: DeltakerTypes
}

export type DeltakerMutationOptions<TData = null> = MutationOptions<
  AxiosResponse<TData>,
  string | Error,
  IDeltakerMutateVars,
  { previousDeltakere: Immutable<IDeltaker[]> }
>
